import { t, type Code } from '../../i18n';

/**
 * A tab whose screen a later step builds (the owner's choice, 2026-10-16; D22): the tab's name
 * and "Coming soon". The step that builds the screen replaces this in App.tsx.
 */
export function ComingSoon({ title }: { title: Code }) {
  return (
    <section className="screen">
      <h1>{t(title)}</h1>
      <p className="muted">{t('soon.text')}</p>
    </section>
  );
}
